import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSessionFeatureFlags } from "~components/FeatureFlagPanel";
import { domainAllowsSessionFeatureFlags } from "~config";
import { BaseContext } from "~context";
import { OrganizationFeatures } from "~lib";

type Features = `${OrganizationFeatures}`;

export const useOrganization = () => {
  const ctx = useContext(BaseContext);
  const { t } = useTranslation();
  const { featureFlags } = useSessionFeatureFlags();

  if (ctx === undefined) {
    throw new Error("Context must be used within a provider!");
  }

  const hasFeature = (feature: Features): boolean => {
    return domainAllowsSessionFeatureFlags
      ? !!featureFlags[feature]
      : ctx?.organization?.features?.includes(feature);
  };

  return { ...ctx, hasFeature, t: t as (key: string) => string };
};
